import React from "react";
import { Chip } from "../../../../components";

const variants = ["contained", "outlined", "text"];
//size = "md", //xs, xs-sm, sm, md, lg, xl
const sizes = ["xs", "xs-sm", "sm", "md", "lg", "xl"];
const colors = [
  "primary",
  "warning",
  "success",
  "danger",
  "info",
  "black",
  "white",
];
const types = ["button", "normal"];
const iconPositions = ["before", "after"];
const disabled = [true, false];
const onDelete = [true, false];

const ChipList = () => {
  return (
    <div className="flex flex-col gap-5 flex-1 overflow-auto my-5">
      <div>
        <Chip
          label="Pushpak Vyas"
          className="!rounded-full text-info bg-white !border-info"
          icon={"add"}
          iconPosition={"before"}
          size="xs"
          onDelete={() => {}}
        />
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        {iconPositions.map((iconPosition, index) => (
          <div key={index} className="flex flex-col gap-5">
            <Chip
              label="Icon Position"
              icon={"add"}
              iconPosition={iconPosition}
            />
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        {disabled.map((onDeleteStatus, index) => (
          <div key={index} className="flex flex-col gap-5">
            <Chip label="Icon Position" disabled={onDeleteStatus} />
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3 items-center">
        {onDelete.map((onDeleteStatus, index) => (
          <div key={index} className="flex flex-col gap-5">
            <Chip label="Icon Position" onDelete={() => {}} />
          </div>
        ))}
      </div>

      <div className="flex flex-wrap gap-3 items-center">
        {colors.map((color, index) => (
          <div key={index} className="flex flex-col gap-5 border-b-2 mb-4">
            {variants.map((variant, index) => (
              <div key={index}>
                {sizes.map((size, sizeIndex) => (
                  <div key={sizeIndex} className="mb-2">
                    <Chip
                      label={`${size}`}
                      color={color}
                      variant={variant}
                      size={size}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChipList;

// import React from "react";
// import { Chip } from "../../../../components";

// const ChipList = () => {
//   return (
//     <div>
//       <Chip
//         label="Pushpak Vyas"
//         className="!rounded-full text-info bg-white !border-info"
//       />
//     </div>
//   );
// };

// export default ChipList;
